<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-WanJu1`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M23.4614 12.3401C23.4614 18.1554 18.7472 22.8696 12.9319 22.8696C7.11658 22.8696 2.40234 18.1554 2.40234 12.3401C2.40234 6.52478 7.11658 1.81055 12.9319 1.81055C18.7472 1.81055 23.4614 6.52478 23.4614 12.3401ZM19.907 17.5282C18.3225 19.655 15.788 21.0325 12.9319 21.0325C11.8872 21.0325 10.8855 20.8482 9.9576 20.5103C11.1806 19.4948 12.8432 18.6345 14.8047 18.0878C16.5538 17.6003 18.3096 17.4266 19.907 17.5282ZM8.08544 19.5571C9.54035 18.1676 11.5967 17.0113 14.0697 16.3221C16.4059 15.671 18.7732 15.5315 20.8968 15.8268C21.3648 14.7595 21.6244 13.5801 21.6244 12.34C21.6244 9.14172 19.8972 6.34688 17.3246 4.83741C16.0638 6.23171 14.2934 7.47613 12.1311 8.37722C9.62466 9.42168 7.00081 9.83431 4.65549 9.67508C4.3853 10.5149 4.23938 11.4104 4.23938 12.34C4.23938 15.3463 5.76557 17.9962 8.08544 19.5571ZM5.44736 7.91671C7.24625 7.91235 9.24573 7.51997 11.1849 6.7119C12.9047 5.99523 14.3439 5.04875 15.4105 4.00594C14.625 3.77269 13.7931 3.64746 12.9319 3.64746C9.74634 3.64746 6.961 5.36104 5.44736 7.91671Z"/></svg>
</template>
<script>

export default {
  name: 'IconWanJu1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
